import React, { useEffect } from 'react';
import AddItem from '../../../ItemAdd';
import {
    Box,
    Table, TableBody, TableContainer, TableRow, TableHead, TableCell, Paper
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { addSupplier, getSuppliers } from '../../../../../../actions/carbonfootprint-rework/04-indirect-ghg-emissions-from-products-used-by-an-organisation/00-suppliers';

export default function SupplierList({ year, companyId, groupId }) {
    // { farmId }
    const dispatch = useDispatch()
    const { suppliers } = useSelector(state => state.indirectGhgEmissionsFromProductsSuppliers)

    useEffect(() => {
        dispatch(getSuppliers(groupId))
    }, [dispatch, groupId])

    const formFields = [
        {
            name: 'name',
            label: 'Supplier Name',
            type: 'text',
            required: true,
        },
        {
            name: 'address',
            label: 'Supplier Address',
            type: 'text',
            required: true,
        },
        {
            name: 'distance',
            label: 'Distance to Supplier in kilometers',
            type: 'number',
            required: true,
        }
    ];

    const initialState = formFields.reduce((obj, field) => {
        obj[field.name] = '';
        return obj;
    }, {});


    const handleFormSubmit = data => {
        dispatch(addSupplier(data, year, companyId, groupId)).then(() => {
            dispatch(getSuppliers(groupId))
        })
    };

    const columns = [
        {
            field: 'name',
            headerName: 'Supplier Name',
            flex: 1,
        },
        {
            field: 'address',
            headerName: 'Address',
            flex: 1,
        },
        {
            field: 'distance',
            headerName: 'Distance (km)',
            flex: 1,
        },
        {
            field: 'created_at',
            headerName: 'Date Created',
            flex: 1
        }
    ]

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ height: '100%' }}>
                <AddItem
                    formFields={formFields}
                    initialState={initialState}
                    onFormSubmit={handleFormSubmit}
                    items={[]}
                    addTitle='Add New Supplier'
                />
                <TableContainer component={Paper} sx={{ height: 'auto' }}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column, index) => {
                                    return (
                                        <TableCell key={index} align="left">
                                            {column.headerName}
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {suppliers?.data?.map((supplier, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell align="left">
                                            {supplier.name}
                                        </TableCell>
                                        <TableCell align="left">
                                            {supplier.address}
                                        </TableCell>
                                        <TableCell align="left">
                                            {supplier.distance}
                                        </TableCell>
                                        <TableCell align="left">
                                            {new Date(supplier.createdAt).toISOString().split('T')[0]}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}
